module.exports = __webpack_public_path__ + "img/icon_home_yw05.ddccd3aa.png";